export const metaConfig = [
	{
		path: '/',
		title: 'Marcial Pons Librero',
		description: 'Albatros integral systems',
		url: 'https://marcialpons.101obex.com/',
	}
];
